exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edited[data-v-93ac373e] {\n  color: #9727c9;\n}\n.edited[data-v-93ac373e]:hover {\n  color: black;\n}\n", ""]);

// exports
